import { Component, Inject, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-edit-truckowner-do",
  templateUrl: "./admin-edit-truckowner-do.component.html",
  styleUrls: ["./admin-edit-truckowner-do.component.css"],
})
export class AdminEditTruckownerDoComponent implements OnInit {
  doForm!: FormGroup;
  doTruckOwnerForm!: FormGroup;
  workorderArray: any;
  truckownerArray: any;
  vehicleArray: any;
  token: any;
  selectedWorkOrderQty: any;
  work_order_msg: any;
  dateFormat = "yyyy-MM-dd";
  language = "en";
  workOrderQnty: any;
  total_quantity: any;
  work_order_qty: any;
  selectedLoadedQuantity: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  updatedDoQty: any;
  usedQty: any;

  constructor(
    private matdialogref: MatDialogRef<AdminEditTruckownerDoComponent>,
    private services: AdminService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public work_order: any
  ) {}
  ngOnInit(): void {
    this.usedQty =
      this.work_order.doInfo?.do_quantity -
      this.work_order.doInfo?.remaining_tons;
    this.token = localStorage.getItem("adminToken");
    this.doTruckOwnerForm = this.formBuilder.group({
      workorder_id: [""],
      act_ton: [""],
      work_date: [""],
      workorder_qty: ["", Validators.pattern(/^^[.0-9]*$/)],
    });
    this.doForm = this.formBuilder.group({
      do_issue_date: [""],
      do_quantity: ["", Validators.pattern(/^[.0-9]*$/)],
      price_per_ton: [""],
      sales_order_no: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[.0-9]*$"),
        ]),
      ],
      pay_as_load_quantity: [""],
      remaining_tons: [""],
      truckowner_id: [""],
      truckowner_number: [""],
      total_tons: [""],
    });
    this.doForm.patchValue({
      do_issue_date: this.work_order.doInfo?.createdAt,
      price_per_ton: this.work_order.doInfo?.price_per_ton,
      sales_order_no: this.work_order.doInfo?.sales_order_no,
      pay_as_load_quantity: this.work_order.doInfo?.pay_as_load_quantity,
      remaining_tons: this.work_order.doInfo?.remaining_tons,
      do_quantity: this.work_order.doInfo?.remaining_tons,
      truckowner_id: this.work_order.doInfo?.truckowner_id?.username,
      truckowner_number: this.work_order.doInfo?.truckowner_id?.mobile,
      total_tons: this.work_order.doInfo?.total_tons,
    });
  }

  updateTO() {
    if (this.doForm.invalid) {
      this.snackBar.open("Please fill all mandatory fields", "Fail", {
        duration: 3000,
      });
      return;
    }

    const updateDoObj = {
      workorder_id: this.work_order.doInfo?.workorder_id,
      truckowner_id: this.work_order.doInfo?.truckowner_id._id,
      do_id: this.work_order.doInfo?.do_id,
      do_issue_date: this.doForm.value.do_issue_date,
      do_quantity: Number(this.doForm.value.do_quantity),
      remaining_tons: this.doForm.value.do_quantity - this.usedQty,
      price_per_ton: Number(this.doForm.value.price_per_ton),
      sales_order_no: this.doForm.value.sales_order_no,
      pay_as_load_quantity:
        this.doForm.value.pay_as_load_quantity || this.selectedLoadedQuantity,
    };
    if (updateDoObj.price_per_ton === 0) {
      this.snackBar.open("Price per ton cannot be zero", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.services.updateDo(updateDoObj, this.token).subscribe(
      (response: any) => {
        if (response.status === 201 || response.status === 200) {
          this.matdialogref.close();
          this.snackBar.open(response.body.message, "Success", {
            duration: 5000,
          });
        }
      },
      (error) => {}
    );
  }

  remainingQnty(event: any) {}
  selectLoadedQty(event: any) {
    this.selectedLoadedQuantity = event;
  }
  close() {
    this.matdialogref.close();
  }
}
